// TOPページ専用（sections/header.liquid で index の時のみ読み込み）
// FVの中にいる間はヘッダーを透明＋白で常に表示し、
// FVを過ぎたら通常色に戻して、下スクロールで隠す／上スクロールで表示する。
(() => {
  const sectionHeader = document.querySelector('.section-header');
  const wrapper = document.querySelector('.header-wrapper--fv');
  const fv = document.querySelector('.fv-slider-wrapper');
  if (!sectionHeader || !wrapper || !fv) return;

  let lastScroll = window.scrollY;

  const isMenuOpen = () => !!wrapper.querySelector('details[open]');

  const update = () => {
    const current = window.scrollY;
    // ヘッダーの下端がFVの下端に達したら切り替える
    const threshold = fv.offsetHeight - sectionHeader.offsetHeight;

    if (current < threshold) {
      wrapper.classList.add('is-fv-transparent');
      sectionHeader.classList.remove('is-fv-hidden');
    } else {
      wrapper.classList.remove('is-fv-transparent');
      if (current > lastScroll && !isMenuOpen()) {
        sectionHeader.classList.add('is-fv-hidden');
      } else if (current < lastScroll) {
        sectionHeader.classList.remove('is-fv-hidden');
      }
    }

    lastScroll = current;
  };

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
